import React from 'react';
import classNames from 'classnames';
import { useField } from 'formik';

import styles from './RadioBtnCard.module.scss';

const {
  'radio-input-card': radioInputCardClass,
  'is-checked': isCheckedClass,
  'card-body': cardBodyClass
} = styles;

const RadioBtnCard = ({ fieldName, value, isChecked, customClass, children, ...props }) => {
  //dynamic classes
  const radioInputCardClasses = classNames(radioInputCardClass, {
    [isCheckedClass]: isChecked
  });

  // form helpers
  const [field, , helpers] = useField(fieldName);
  const { setValue } = helpers;

  return (
    <div className={`${radioInputCardClasses} ${customClass}`} onClick={() => setValue(value)}>
      <label htmlFor={props?.name}>
        <input {...field} {...props} type="radio" value={value} checked={isChecked} />
        <span />
      </label>
      <div className={cardBodyClass}>{children}</div>
    </div>
  );
};

export default RadioBtnCard;
